import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getAemState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.aem
);

export const shouldTriggerAemApi = createSelector(
  getAemState,
  ({ isReady }) => !isReady
);

export const isAemStateReady = createSelector(
  getAemState,
  ({ isReady, isError }) => isReady || isError
);

export const getBookWidgetAem = createSelector(
  getAemState,
  ({ bookWidgetAem }) => bookWidgetAem
);
